<app-header></app-header>
<div class="addPayment">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-5 col-sm-8">
        <div class="addPayment__tab">
          <h4>Make Payment</h4>
          <p>Valid for 1 year/resume</p>
          <form #loginForm="ngForm">
            <h1 class="addPayment__cost">$1.99</h1>
            <div class="form-group">
              <input class="btn btn-primary btn-block" type="submit" value="Pay Now">
            </div>
            <button class="btn btn-sm btn-link" type="button" routerLink="/profile">Cancel Payment</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
